import { Link } from '@tanstack/react-router'
import { Layout } from 'antd'
import clsx from 'clsx'
import { type FC } from 'react'

import { AppLogo } from '@/features/shared/components'
import { type UserMeExEntity, type UserMeTenantExEntity } from '@/libs/api'

import { useSiderCollapsed } from '../../-hooks'
import { CollapseTrigger } from '../CollapseTrigger'
import { SideMenu } from '../SideMenu'

const { Sider: AntdSider } = Layout

type Props = {
  authUser: UserMeExEntity
  currentTenant: UserMeTenantExEntity
}

export const Sider: FC<Props> = ({ authUser, currentTenant }) => {
  const { collapsed, toggle } = useSiderCollapsed()
  const { key: tenantKey } = currentTenant

  return (
    <div className="sticky top-0 z-10 h-svh">
      <AntdSider
        width={230}
        collapsedWidth={46}
        trigger={null}
        theme="light"
        className="h-full overflow-y-auto overscroll-contain"
        style={{ height: '100%' }}
        collapsible
        collapsed={collapsed}
        onCollapse={toggle}
      >
        <div
          className={clsx([
            'flex h-app-header items-center',
            collapsed ? 'justify-center' : 'px-4'
          ])}
        >
          <Link to="/$tenantKey" params={{ tenantKey }}>
            <AppLogo
              collapsed={collapsed}
              className={clsx(['hover:text-primary'])}
            />
          </Link>
        </div>
        <CollapseTrigger collapsed={collapsed} onClick={toggle} />
        <SideMenu
          defaultOpenKeys={
            collapsed ? [''] : ['dispatch-work', 'master', 'system_master']
          }
          authUser={authUser}
          tenantKey={tenantKey}
        />
      </AntdSider>
    </div>
  )
}
